<template>
	<div>
		<div id="mapblock" class="mapblock"></div>
	</div>
</template>

<script>
  import 'leaflet'

  export default {
    name: "show-coord",

    data() {
      return {
        myMap: '',
        bounds: [],
        map_coord: [],
      }
    },
    props: {
      geo: ''
    },
    methods: {
      map() {

        let app = this;

        let googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        });

        let googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        });

        //let map = L.map('mapblock').setView(this.map_coord, 17);
        let map = L.map('mapblock', {
          center: this.map_coord,
          zoom: 17,
          layers: [googleStreets, googleHybrid]
        });

        let baseMaps = {
          "Схема": googleStreets,
          "Спутник": googleHybrid
        };

        L.control.layers(baseMaps, '', {
          collapsed: false
        }).addTo(map);

        /*L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);*/

        //googleHybrid.addTo(map);
        L.control.locate({
          strings: {
            title: "Определить моё местоположение"
          }
        }).addTo(map);
        L.marker(this.map_coord).addTo(map);

       /* L.Routing.control({
          waypoints: [
            L.latLng(57.74, 11.94),
            L.latLng(57.6792, 11.949)
          ]
        }).addTo(map);*/

        this.myMap = map;
      },
    },
    mounted() {
      if(this.geo){
        this.map_coord = this.geo.split(',');
      }
      this.map();
    },
    updated() {
      console.log('updated');
    }
  }
</script>